/**
 * Reusable validation utilities.
 */

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Returns true if the value is a valid email address. */
export function isValidEmail(value: string): boolean {
  return EMAIL_RE.test(value.trim());
}

/**
 * Sanitises a phone input so it only contains digits and an optional
 * leading `+`.  Call this from an onChange handler to restrict input.
 *
 * Example: `"+1 (555) abc 123"` → `"+1555123"`
 */
export function sanitizePhone(value: string): string {
  // keep only + and 0-9, then ensure + only appears at the start
  return value
    .replace(/[^+\d]/g, "")
    .replace(/(?!^)\+/g, "");
}

/** Returns true if the value looks like a valid phone number (digits, optional leading +). */
export function isValidPhone(value: string): boolean {
  return /^\+?\d{7,15}$/.test(value.trim());
}
